import { render, staticRenderFns } from "./ModalTagihan.vue?vue&type=template&id=f2ae1df8"
import script from "./ModalTagihan.vue?vue&type=script&lang=js"
export * from "./ModalTagihan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports